import React from 'react'
import { AlertTriangle, X } from 'lucide-react'
import styles from './index.module.scss'
import { useAppDispatch, useAppSelector } from '../../store/storeHooks'
import { selectBannerState, setBannerIsShown } from '../../store/bannerSlice'

const NotificationBanner: React.FC = () => {
  const dispatch = useAppDispatch()
  const { isShown, communications } = useAppSelector(selectBannerState)

  const onClickCloseBannerIcon = () => {
    dispatch(setBannerIsShown(false))
  }

  if (isShown) {
    return (
      <div className={styles.banner}>
        <div className={styles.content}>
          <AlertTriangle size={20} className={styles.icon} color={'#ffcd00'} />
          <div className={styles.message} style={{ color: '#333333' }}>
            {communications}
          </div>
        </div>

        <button onClick={onClickCloseBannerIcon} className={styles.closeButton} aria-label='Close'>
          <X size={16} />
        </button>
      </div>
    )
  }

  return null
}

export default NotificationBanner
